import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { colors, textStyles } from '../../../../theme';
export default {
  container: {},
  inputContainer: {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    padding: '0',
    border: [[1, 'solid', colors.pureBlack]],
    borderColor: function borderColor(_ref) {
      var focused = _ref.focused,
        error = _ref.error;
      return focused && !error && colors.pureBlack || error && colors.error || colors.pureBlack;
    },
    backgroundColor: function backgroundColor(_ref2) {
      var disabled = _ref2.disabled,
        error = _ref2.error;
      return disabled && colors.lightGrey || error && 'rgba(220, 11, 11, 0.05)' || colors.pureWhite;
    }
  },
  label: _objectSpread(_objectSpread({
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    overflow: 'hidden'
  }, textStyles.tiny), {}, {
    color: function color(_ref3) {
      var focused = _ref3.focused,
        error = _ref3.error;
      return focused && !error && colors.midGrey || error && colors.error || colors.midGrey;
    },
    '&[for]': {
      cursor: 'auto'
    },
    '& > $formLabel': {
      cursor: 'pointer'
    }
  }),
  formLabel: {},
  formPlaceholder: {},
  input: _objectSpread(_objectSpread({
    flex: 1,
    border: 0,
    padding: '1.1rem 1rem 0.9rem'
  }, textStyles.label), {}, {
    lineHeight: 1.2,
    color: function color(_ref4) {
      var disabled = _ref4.disabled;
      return disabled && colors.midGrey || colors.pureBlack;
    },
    background: 'transparent',
    opacity: 1,
    /* required on iOS */
    '&:disabled': {
      color: colors.midGrey,
      cursor: 'not-allowed'
    }
  }),
  ornament: {
    padding: [['0', '0.5rem']]
  },
  startOrnament: {},
  endOrnament: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center'
  },
  errorText: _objectSpread(_objectSpread({}, textStyles.tiny), {}, {
    fontSize: '1rem'
  }),
  helpText: {}
};